export default __webpack_public_path__ + "static/bed-bath-beyond-8-a-7ece740a2a39d8bbee7b4e9c4369d2db.webp";